import { FC, memo } from 'react';
import { Button, ButtonProps } from '@components/UIKit/Button/Button';
import { useTranslation } from '@hooks/useTranslation';
const defaultButtonProps: Omit<ButtonProps, 'children' | 'id'> = {
  size: 'medium',
  color: 'Black'
};
interface Props {}
const MemoizedLoadingButton: FC<Props> = () => {
  const {
    translate: tr
  } = useTranslation();
  return <Button id='loading_button' {...defaultButtonProps} loading data-sentry-element="Button" data-sentry-component="MemoizedLoadingButton" data-sentry-source-file="LoadingButton.tsx">
			{tr({
      id: 'btn.loading'
    })}
		</Button>;
};
export const LoadingButton = memo(MemoizedLoadingButton);